import { ViewContainerRef, Component, AfterViewInit, OnInit, ViewChild, ElementRef, HostListener, ChangeDetectorRef, ComponentFactoryResolver } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first, map } from 'rxjs/operators';

import { AlertService, ExamService, OpentokService } from '../_services';
import { Globals } from '../_helpers';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { Observable, throwError } from 'rxjs';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { SubscriberComponent } from '../subscriber/subscriber.component';
import * as OT from '@opentok/client';
import config from '../../config';

const publish = () => {

};
export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}



@Component({
    selector: 'student-practical',
    templateUrl: './practical-page.component.html',
    styleUrls: ['./test-viva-page.component.css']
})
export class PracticalComponent implements AfterViewInit, OnInit {
    @ViewChild('publisherDiv') publisherDiv: ElementRef;
    @ViewChild('subscriberHost', { read: ViewContainerRef}) subscriberHost: ViewContainerRef;
    @ViewChild('keysExpireSwal') private keysExpireSwal: SwalComponent;
    @ViewChild('keysnofoundSwal') private keysnofoundSwal: SwalComponent;
    @ViewChild('practicalEndSwal') private practicalEndSwal: SwalComponent;
    @ViewChild('disconnectSwal') private disconnectSwal: SwalComponent;

    public alertOption: SweetAlertOptions = {};

    matcher = new MyErrorStateMatcher();

    @HostListener('window:keyup', ['$event'])
    onKeyupHandler(event: KeyboardEvent) {
        if (event.keyCode == 123 || event.keyCode == 122)
            //this.autoSubmitAnswers('manual');
            /*console.log(event.keyCode);*/
            event.stopPropagation();
    }

    studentName: string = '';
    studentCode: string = '';
    loading = false;
    userData = {};
    settings = {};
    vcsettings = {};
    isPause = false;
    isResetBtn = false;
    returnUrl: string;
    is_over: number = 0;
    keys : any;
    disconnect : number = 0;
    interval;

    TOKEN = '';
    SESSION_ID = '';

    /* webcam Settings */
    public showWebcam = true;
    public allowCameraSwitch = true;
    public multipleWebcamsAvailable = false;
    public deviceId: string;

    /*open tok */
    session: OT.Session;
    //streams: Array<OT.Stream> = [];
    changeDetectorRef: ChangeDetectorRef;
    publisher: OT.Publisher;
    sessionid: string = '';
    token: string = '';
    //@ViewChild('publisherDiv') publisherDiv: ElementRef;
    publishing: Boolean;
    static: Boolean;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private examService: ExamService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private domSanitizer: DomSanitizer,
        private ref: ChangeDetectorRef,
        private opentokService: OpentokService,
        private componentFactoryResolver: ComponentFactoryResolver,        
    ) {
        this.changeDetectorRef = ref;
        this.publishing = false;
    }

    ngOnInit() {
        var step = this.route.snapshot.paramMap.get("step");
        /*if(step != this.globals.complSteps['theory-test'])
            this.router.navigateByUrl('/login');*/

        if(this.globals.isPracticalOver)
            this.router.navigateByUrl('/login'); 

        //this.requestFullscreen(document.documentElement);

        this.userData = JSON.parse(localStorage.getItem('currentUser'));
        this.settings = JSON.parse(sessionStorage.pkshn_vc_set);
        this.vcsettings = JSON.parse(sessionStorage.pkshn_vc_setting);
        this.studentName = this.userData['name'];
        this.studentCode = this.userData['code'];

       // get return url from route parameters or default to '/'
        this.returnUrl = '/';

        /*WebcamUtil.getAvailableVideoInputs()
        .then((mediaDevices: MediaDeviceInfo[]) => {
            this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
        });*/

        if (this.settings['practicalid'] != 0 || this.settings['practicalid'] != '') {

/*            this.publisher = OT.initPublisher(this.publisherDiv.nativeElement, {insertMode: 'append',width:330, height:250});  

            this.opentokService.initSession().then((session: OT.Session) => {
              this.session = session;
              this.session.on('streamCreated', (event) => {
                 const subscriber = this.session.subscribe(event.stream, this.subscriberDiv.nativeElement, {width: 700, height: 500, insertMode: 'append'}, (err) => {
                    if (err) {
                        alert(err.message);
                    }
                });                  
                this.streams.push(event.stream);
                this.changeDetectorRef.detectChanges();
              });
              this.session.on('streamDestroyed', (event) => {
                  alert('streamDestroyed');                  
                const idx = this.streams.indexOf(event.stream);
                if (idx > -1) {
                  this.streams.splice(idx, 1);
                  this.changeDetectorRef.detectChanges();
                }
              });
            })
            .then(() => this.opentokService.connect())
            .catch((err) => {
              console.error(err);
              this.keysExpireSwal.show(); 
            }); */


// this.keysExpireSwal.show();     
        }
    }
  publish() {
    this.session.publish(this.publisher, (err) => {
      if (err) {
        console.log(err)
      }
      else {
        this.publishing = true;
      }
    });
  }

  onStreamCreated(stream) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(SubscriberComponent);

    const viewContainerRef = this.subscriberHost;
    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<SubscriberComponent>componentRef.instance).stream = stream;
    (<SubscriberComponent>componentRef.instance).session = this.session;
    (<SubscriberComponent>componentRef.instance).subscribe();
  } 
  ngAfterViewInit(): void {  
      if(this.vcsettings['sid'] != 0 && this.vcsettings['tid'] != 0)
      {
          //console.log(config.API_KEY);  
        this.publisher = OT.initPublisher
          (
            this.publisherDiv.nativeElement, {
            height: "250px",
            width: "320px",
            insertMode: 'append'
          });
        this.session = OT.initSession(config.API_KEY, this.vcsettings['sid']);
        this.session.connect(this.vcsettings['tid'], (err) => {
          if (err) {
             this.keysExpireSwal.show(); 
             console.log(err);
          }
          else {
            console.log("connected");
            this.publish()
            let that = this;
            this.session.on("streamCreated", function (event) {
              that.onStreamCreated(event.stream);
            });
            this.session.on("streamDestroyed", function (event) {
                console.log("The publisher stopped streaming. Reason: "+ event.reason);  
/*                if(event.reason === "clientDisconnected")
                {
                  that.disconnect = 1;
                  console.log(that.is_over);
                  that.keys = setInterval(() => { // 
                    if(that.disconnect > that.vcsettings['vccount'])
                    //if(that.is_over == 1)
                    {
                        clearInterval( that.keys ); 
                        that.disconnectSwal.show();                       
                    }
                    else if(that.is_over == 1 || that.is_over == 2)
                    {
                        clearInterval( that.keys );
                    }
                    else
                    {
                        that.disconnect++;
                        that.checkPracticalVC();
                    }
                  }, 2000);                   
                }*/
                if(event.reason == "forceDisconnected")
                {
                    that.practicalEndSwal.show();                  
                }                
      
            });

             this.session.on("sessionDisconnected", function (event) {
              console.log("The publisher disconnect streaming"); 
/*              this.publisher.publishAudio(false); 
              this.publisher.publishVideo(false); */
              //subscribeToVideo(false)      
            });  
            this.interval = setInterval(() => {
                this.checkPracticalVC(); 
            }, 8000);  

          }
        })  
      }
      else
      {
        this.keysnofoundSwal.show();         
      }
  } 

    public redirectLogin()
    {
        var sessionObj = this.session;
        sessionObj.unpublish(this.publisher);
        this.publisher.destroy();
        this.router.navigateByUrl('/login');
    }     
    public redirectWelcome()
    {
        var qstring = this.userData['usercode']+'//@spwd++sup@//'+this.settings['examid']+'//@spwd++sup@//'+this.settings['practicalid']+'//@spwd++sup@//'+this.userData['id'];
        var parms = window.btoa(qstring);
        this.router.navigateByUrl('/practical-welcome/'+parms);   
    }
    public audioOnOff(btnIndex)
    {
        if ( document.getElementById('btn-' + btnIndex).classList.contains('img_mike') == true)
        {
            document.getElementById('btn-' + btnIndex).classList.remove("img_mike");
            document.getElementById('btn-' + btnIndex).classList.add("img_mikes");
            this.publisher.publishAudio(true);
        }
        else{
            document.getElementById('btn-' + btnIndex).classList.add("img_mike");
            this.publisher.publishAudio(false);
        }
    } 
    public videoOnOff(btnIndex)
    {
        if ( document.getElementById('btn-' + btnIndex).classList.contains('img_mike') == true)
        {
            document.getElementById('btn-' + btnIndex).classList.remove("img_mike");
            document.getElementById('btn-' + btnIndex).classList.add("img_mikes");
            this.publisher.publishVideo(true);
        }
        else{
            document.getElementById('btn-' + btnIndex).classList.add("img_mike");
            this.publisher.publishVideo(false);
        }
    } 
    public subsaudioOnOff(btnIndex)
    {
        if ( document.getElementById('btn-' + btnIndex).classList.contains('img_mike') == true)
        {
            document.getElementById('btn-' + btnIndex).classList.remove("img_mike");
            document.getElementById('btn-' + btnIndex).classList.add("img_mikes");
            this.publisher.publishAudio(true);
        }
        else{
            document.getElementById('btn-' + btnIndex).classList.add("img_mike");
            this.publisher.publishAudio(false);
        }
    }     
    public checkPracticalVC() {
        this.examService.checkPractical(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['examid'], this.settings['practicalid'])
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) {
                  if(data.prac_end == 1 || data.prac_end == 2)
                  {
                    this.is_over = data.prac_end;
                    this.keys = data.prac_end;
                    //clearInterval( this.keys );
                    clearInterval( this.interval );
                    this.publisher.publishAudio(false); 
                    this.publisher.publishVideo(false);                     
                    this.practicalEndSwal.show(); 
                  } 
                  else
                  {
                    this.is_over = 0;                      
                  }              
              }
              else if (data.code == 1001) {
                this.is_over = 0;
              }
            }
          )
    }
    public endPracticalAuto()
    {
        var sessionObj = this.session;
        sessionObj.unpublish(this.publisher);
        this.publisher.destroy();
        var parms = this.globals.getRandUrl('upload-idpic');
        this.router.navigateByUrl('/practical-end/' + parms); 
    }


    /*public triggerSnapshot(): void {
        this.trigger.next();
        this.imagePath = this.webcamImage.imageAsDataUrl;
        this.isPicTaken = false;
    }*/

    /* public toggleWebcam(): void {
         this.showWebcam = !this.showWebcam;
     }*/

    /*public handleInitError(error: WebcamInitError): void {
        this.errors.push(error);
    }*/

    /*public showNextWebcam(directionOrDeviceId: boolean|string): void {
        // true => move forward through devices
        // false => move backwards through devices
        // string => move to device with given deviceId
        this.nextWebcam.next(directionOrDeviceId);
    }*/

    /*public handleImage(webcamImage: WebcamImage): void {
        this.webcamImage = webcamImage;
    }*/

    /*public cameraWasSwitched(deviceId: string): void {
        this.deviceId = deviceId;
    }*/

    /*public get triggerObservable(): Observable<void> {
        return this.trigger.asObservable();
    }*/

    /*public get nextWebcamObservable(): Observable<boolean|string> {
        return this.nextWebcam.asObservable();
    }*/

    /*public webCameScreen(): void{
        this.isPicTaken = true;
    }*/
} 